import React, { useEffect, useMemo, useState,useCallback } from "react";
import { useTable, useSortBy, usePagination, useRowSelect } from "react-table";
import "tailwindcss/tailwind.css";
import { Empty } from "antd";
import "../../styles.css";
import Vectorsorting from "../../assets/Vectorsorting.svg";
import ShimmerLoader from "../../loading";
import { useTranslation } from "react-i18next";
import { Navigate, useNavigate } from "react-router-dom";
import CustomPagination from "../../components/CustomWidgets/CustomPagination";
import { useSelector } from "react-redux";
import Edit from "../../assets/Edit.svg";
import { DataGrid } from "@mui/x-data-grid";
import Box from '@mui/material/Box';
import { filter } from "framer-motion/client";
import { debounce } from "@mui/material";


const FilterInput = React.memo(({ item, applyValue, onSearch, setPaginationModel }) => {
  const handleChange = useCallback(
    debounce((val) => {
      if (val === "") {
        setPaginationModel({ page: 0, pageSize: 10 });
        onSearch("");
      } else {
        onSearch(val);
      }
    }, 500),
    [onSearch, setPaginationModel]
  );

  return (
    <input
      style={{ height: 40, fontSize: 13, border: "1px solid #ccc", borderRadius: 4, padding: "0 8px" }}
      defaultValue={item.value ?? ""}
      placeholder="Search By Customer Name"
      onChange={(e) => {
        const val = e.target.value;
        applyValue({ ...item, value: val });
        handleChange(val);
      }}
    />
  );
});




const NewCustomersTable = ({ additionalData, pagination, onSearch, filterModel, onFilterModelChange, showDrawer, onEditLine }) => {
  const { t, i18n } = useTranslation();
  const [flag, setflag] = useState(false);
  const navigate = useNavigate();
  const [query, setquery] = useState("");

  const allStores = useSelector(
    (state) => state?.storeReducer?.selectedStore?.is_select_all_store
  )

  const openOrderList = (id) => {
    // console.log("CREDIT CUS TOME id", id);

    navigate(`/customerCreditOrder?id=${id}`);
  };

  const data = useMemo(
    () =>
      //   additionalData?.status
      //     ? additionalData?.all_product
      additionalData || [],
    [additionalData]
  );

  const formatAddress = (address, t) => {
    if (!address) return "";

    const parts = [];

    if (address.add_field_1) {
      parts.push(
        `${address.name === "Villa"
          ? t("Villa No.-")
          : address.name === "Apartment"
            ? t("Building-")
            : address.name === "Office"
              ? t("Company-")
              : ""
        } ${address.add_field_1}`
      );
    }

    if (address.add_field_2) {
      parts.push(
        `${address.name === "Villa"
          ? t("Group No.-")
          : address.name === "Apartment"
            ? t("Apartment No.-")
            : address.name === "Office"
              ? t("Floor-")
              : ""
        } ${address.add_field_2}`
      );
    }

    if (address.add_field_3) {
      parts.push(
        `${address.name === "Villa"
          ? t("Street-")
          : address.name === "Apartment"
            ? t("Floor-")
            : address.name === "Office"
              ? t("Building-")
              : ""
        } ${address.add_field_3}`
      );
    }

    if (address.add_field_4) {
      parts.push(address.add_field_4);
    }

    return parts.join(", ");
  };

  useEffect(() => {
    if (additionalData?.length === 0 && !flag) {
      const timer = setTimeout(() => {
        setflag(true);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [additionalData, flag]);

  // ✅ CORRECT - extract as a proper React component

  const muiColumns = useMemo(() => [
    {
      field: "name",
      headerName: t("Customer Name"),
      flex: 1,
     filterOperators: [
  {
    label: "contains",
    value: "contains",
    getApplyFilterFn: () => () => true,
    InputComponent: ({ item, applyValue }) => (
      <FilterInput
        item={item}
        applyValue={applyValue}
        onSearch={onSearch}
        setPaginationModel={setPaginationModel}
      />
    ),
  },
],
      renderCell: (params) => (
        <div>{params.row.name}</div>
      ),
    },
    {
      field: "phone",
      headerName: t("Phone Number"),
      flex: 1,
    },
    {
      field: "address",
      headerName: t("Address"),
      flex: 2,
      filterable: false,
      valueGetter: (value, row) => {
        const address = row.addresses?.[0];
        return formatAddress(address, t);
      },
      renderCell: (params) => {
        <div>{params.value}</div>
      }
    },
    {
      field: "credit_amount",
      headerName: t("Credit Amount"),
      flex: 1,
      filterable: false,
      renderCell: (params) => (
        <div>{`EGP ${params.row.credit_amount}`}</div>
      ),
    },
    {
      field: "status",
      headerName: t("Status"),
      flex: 1,
      renderCell: (params) => {
        const isUnpaid = params.row.credit_amount > 0;

        return (
          <span
            className={`flex justify-center font-normal text-sm rounded-xl px-3 py-1 ${isUnpaid
              ? "bg-[#FFEBC5] text-[#E8A700]"
              : "bg-[#D1FFDE] text-[#00B833]"
              }`}
          >
            {isUnpaid ? t("Unpaid") : t("Paid")}
          </span>
        );
      },
    },
    {
      field: "History",
      headerName: t("History"),
      flex: 1,
      filterable: false,
      sortable: false,
      renderCell: (params) => (
        <div style={{ display: "flex", alignItems: "center", height: "100%" }}>
          <button
            onClick={(e) => {
              e.stopPropagation();
              showDrawer(params.row);
            }}
            className="font-semibold w-36 h-8 text-sm border border-primaryBlue rounded-lg bg-white text-primaryBlue flex justify-center items-center gap-2"
          >
            {t("Payment History")}
          </button>
        </div>
      ),
    },
    {
      field: "Action",
      headerName: t("Action"),
      width: 80,
      filterable: false,
      sortable: false,
      renderCell: (params) => (
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100%", width: "100%" }}>
          <img
            src={Edit}
            className="cursor-pointer h-4 w-4"
            alt="Edit"
            onClick={(e) => {
              e.stopPropagation();
              onEditLine(params.row);
            }}
          />
        </div>
      ),
    },
  ], [t, showDrawer, onEditLine]);


  const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 10 });

  useEffect(() => {
    // when pagination changes, tell parent
    pagination({
      limit: paginationModel.pageSize,
      offset: paginationModel.pageSize * paginationModel.page,
    });
  }, [paginationModel]);





  return (
    <>
      <div
        className="container flex flex-col mx-auto mt-4"
        style={{ maxWidth: "100%" }}
      >
        {additionalData?.length == 0 && flag == false ? (
          <div className="h-screen w-[90%] mt-2 ">
            <div />
          </div>
        ) : (
          <>
            <Box
              sx={{
                height: 650,
                width: "100%",
                "& .MuiDataGrid-root": {
                  border: "none",
                  borderRadius: "12px",
                  overflow: "hidden",
                  fontFamily: "'Inter', sans-serif",
                  fontSize: "13px",
                  boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
                  backgroundColor: "#fff",
                },
                "& .MuiDataGrid-columnHeaders": {
                  backgroundColor: "#EBF7FD",
                  borderBottom: "1.5px solid #78CFEC",
                  minHeight: "48px !important",
                },
                "& .MuiDataGrid-columnHeader": {
                  padding: "0 16px",
                  color: "#1A6F8A",
                  fontWeight: 600,
                  fontSize: "12.5px",
                  textTransform: "uppercase",
                  letterSpacing: "0.04em",
                },
                "& .MuiDataGrid-columnSeparator": {
                  display: "none",
                },
                "& .MuiDataGrid-cell": {
                  padding: "0 16px",
                  borderBottom: "1px solid #F0F4F8",
                  color: "#272728",
                  display: "flex",
                  alignItems: "center",
                },
                "& .MuiDataGrid-row": {
                  minHeight: "52px !important",
                  transition: "background 0.15s ease",
                },
                "& .MuiDataGrid-row:hover": {
                  backgroundColor: "#F0F9FD",
                  cursor: "pointer",
                },
                "& .MuiDataGrid-row.Mui-selected": {
                  backgroundColor: "#DBEEFA !important",
                },
                "& .MuiDataGrid-row.Mui-selected:hover": {
                  backgroundColor: "#CCE8F6 !important",
                },
                "& .MuiDataGrid-checkboxInput": {
                  color: "#78CFEC",
                },
                "& .MuiCheckbox-root.Mui-checked": {
                  color: "#0EA5D0",
                },
                "& .MuiDataGrid-footerContainer": {
                  borderTop: "1.5px solid #E2EEF4",
                  backgroundColor: "#F7FBFD",
                  minHeight: "48px",
                },

                "& .MuiDataGrid-virtualScroller": {
                  backgroundColor: "#FAFCFE",
                },
                "& .MuiDataGrid-overlayWrapper": {
                  minHeight: "120px",
                },
                "& .MuiDataGrid-columnHeaderTitleContainer": {
                  gap: "4px",
                },
                "& .MuiDataGrid-sortIcon": {
                  color: "#78CFEC",
                },
                "& .MuiDataGrid-menuIcon": {
                  color: "#78CFEC",
                },

                "& .MuiTablePagination-selectLabel": {
                  display: "none",   // hides "Rows per page"
                },
              }}
            >
              <DataGrid
                rows={data}
                columns={muiColumns}
                getRowId={(row) => row.pos_credit_id || row.customer_id || Math.random()}
                onRowClick={(params) => openOrderList(params.row.customer_id)}
                // onFilterModelChange={handleFilterChange}
                // filterModel={filterModel}

                paginationMode="server"
                rowCount={-1}
                paginationModel={paginationModel}
                onPaginationModelChange={setPaginationModel}
                pageSizeOptions={[10, 25, 50]}

              />
            </Box>
          </>
        )}
      </div>
    </>
  );
};

export default NewCustomersTable;